import { render } from "./PoweredByInspiration.vue.js?vue&type=template&id=11555c37!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PoweredByInspiration.vue?vue&type=template&id=11555c37"
import script from "./PoweredByInspiration.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PoweredByInspiration.vue?vue&type=script&lang=js"
export * from "./PoweredByInspiration.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PoweredByInspiration.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/components/join-publication/PoweredByInspiration.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "11555c37"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('11555c37', __exports__)) {
    api.reload('11555c37', __exports__)
  }
  
  module.hot.accept("./PoweredByInspiration.vue.js?vue&type=template&id=11555c37!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PoweredByInspiration.vue?vue&type=template&id=11555c37", () => {
    api.rerender('11555c37', render)
  })

}


export default __exports__